import { CustomRouteProps } from 'common/models/navigationModel';

import { BenefitPriorityDashboardContainer } from '../containers/BenefitPriorityDashboardContainer';
import { BenefitsDashboardContainer } from '../containers/BenefitsDashboardContainer';
import { BenefitTemplateDashboardContainer } from '../containers/BenefitTemplateDashboardContainer';
import { ContractDashboardContainer } from '../containers/ContractDashboardContainer';
import { ContractPriorityDashboardContainer } from '../containers/ContractPriorityDashboardContainer';
import { DashboardPaths } from '../models/dashboardModel';

const menuLinks = [
    { key: DashboardPaths.Benefits, label: 'Benefits' },
    { key: DashboardPaths.BenefitTemplates, label: 'Benefit Templates' },
    { key: DashboardPaths.BenefitPriorities, label: 'Benefit Priorities' },
    { key: DashboardPaths.Contracts, label: 'Projects' },
    { key: DashboardPaths.ContractPriorities, label: 'Project Priorities' },
];

export const dashboardRoutes: CustomRouteProps[] = [
    {
        path: DashboardPaths.Contracts,
        component: ContractDashboardContainer,
        exact: true,
    },
    {
        // :tab drives the sub-dashboard so each one is linkable and the sub menu can
        // highlight from the URL, the same way the benefit pages do.
        path: `${DashboardPaths.Benefits}/:tab?`,
        component: BenefitsDashboardContainer,
        exact: true,
    },
    {
        path: DashboardPaths.BenefitTemplates,
        component: BenefitTemplateDashboardContainer,
        exact: true,
    },
    {
        path: DashboardPaths.ContractPriorities,
        component: ContractPriorityDashboardContainer,
        exact: true,
    },
    {
        path: DashboardPaths.BenefitPriorities,
        component: BenefitPriorityDashboardContainer,
        exact: true,
    },
].map((route) => ({
    ...route,
    menuLinks,
}));
